import { render, staticRenderFns } from "./EquipmentFitmentViewDialog.vue?vue&type=template&id=36c860e1&scoped=true"
import script from "./EquipmentFitmentViewDialog.vue?vue&type=script&lang=ts"
export * from "./EquipmentFitmentViewDialog.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentFitmentViewDialog.vue?vue&type=style&index=0&id=36c860e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c860e1",
  null
  
)

export default component.exports